import { memo } from 'react'
import { OrderPicklistExtraItem } from '../components/types'
import { EditorProps } from 'react-data-grid'
import Modal from './Modal'
import { MdOutlineLibraryAdd } from 'react-icons/md'
import { useForm } from 'react-hook-form'

const CopyReturnItemEditor = memo(({ props } : {
  props: EditorProps<OrderPicklistExtraItem | null>
}) => {
  const { onClose, onRowChange, row } = props

  const { 
    register, watch, getValues
  } = useForm<{ normal: boolean, withSh: boolean, waste: boolean }>({
    defaultValues: {
      normal: false,
      withSh: false,
      waste: false
    }
  })

  const isNormal = watch('normal')
  const isSh = watch('withSh')
  const isWaste = watch('waste')

  let countOfLine = 0
  if (isNormal) countOfLine++
  if (isSh) countOfLine++
  if (isWaste) countOfLine++

  return <Modal show={true} onHide={onClose}
    okTheme='primary'
    okText={`สร้างใหม่ ${countOfLine} บรรทัด`}
    okAction={() => {
      const { normal, withSh, waste } = getValues()
      let updatedRow = { 
        ...row,
        copyToNormal: normal,
        copyToWithSh: withSh,
        copyToWaste: waste,
      } as OrderPicklistExtraItem
      onRowChange(updatedRow, true)
    }}
    cancelText='ยกเลิก'
    title={`เพิ่มบรรทัดใหม่`}
    maxWidth={'max-w-2xl'}
    okDisable={countOfLine === 0}
    >
    <div className='flex items-center gap-3'>
      <MdOutlineLibraryAdd size={64} className='text-slate-500 basis-1/6 ' />
      <div className='space-y-3 '>
        <h6 className='font-light '>คุณกำลังเพิ่มบรรทัดใหม่ของ</h6>
        <h5 className='font-bold underline '>{row?.materialCode} - {row?.materialDescription}</h5>
        <h6 className='font-light '>กรุณาเลือกอย่างน้อย 1 ช่องคืน</h6>
        <form>
          <div className="form-check">
            <input className="float-left w-4 h-4 mt-1 mr-2 align-top" type="checkbox" value="" id="returnNormal" 
            {...register('normal')} />
            <label className="inline-block font-bold text-green-600 form-check-label" htmlFor="returnNormal">คืนดีปกติ</label>
          </div>
          <div className="form-check">
            <input className="float-left w-4 h-4 mt-1 mr-2 align-top" type="checkbox" value="" id="returnWithSh"
            {...register('withSh')} />
            <label className="inline-block font-bold text-green-600 form-check-label" htmlFor="returnWithSh">คืนดีติด SH/STK</label>
          </div>
          <div className="form-check">
            <input className="float-left w-4 h-4 mt-1 mr-2 align-top" type="checkbox" value="" id="returnWaste"
            {...register('waste')} />
            <label className="inline-block font-bold text-red-500 form-check-label" htmlFor="returnWaste">คืนเสีย</label>
          </div>
        </form>
        <h6 className='font-light '>ระบบจะกรอกยอด <span className='font-bold underline'>1 หน่วย</span> ให้เริ่มต้น กรุณาปรับจำนวนให้ถูกต้องก่อน POST</h6>
      </div>
    </div>
    </Modal>
})

export default memo(CopyReturnItemEditor)